// import { firebase, ref, set } from '@react-native-firebase/database';
import moment from "moment";
import fword from "../datafiles/fword_data.json";
import { GetSystemSetData } from "./ApiCommon";
import { GetStringByKey } from "./ApiTranslate";

// const database = firebase.app().database('https://pushtest-linkid-default-rtdb.asia-southeast1.firebasedatabase.app/');

// 자동호출하기 타이머
export const autoSendCallTimer = 300000; //300000  = 5분

// 단건 메세지 보내기.
export const sendMsg = async (
  isBeta,
  database,
  partyid,
  msg,
  from_uid,
  to_uid,
  time,
  isRead,
  host_uid,
  guest_uid
) => {
  // console.log(partyid, msg, from_uid, to_uid, time, isRead, host_uid, guest_uid);
  const ref = isBeta
    ? database.ref(
        "Beta/Messages/" + partyid + "@" + host_uid + "@" + guest_uid
      )
    : database.ref(
        "Live/Messages/" + partyid + "@" + host_uid + "@" + guest_uid
      );

  try {
    return await ref
      .push({
        message: {
          sender: from_uid,
          receiver: to_uid,
          msg: msg,
          time: time,
          isRead: isRead,
        },
      })
      .then(() => {});
  } catch (error) {
    return error;
  }
};

export const saveLatestMsg = async (
  isBeta,
  database,
  from_uid,
  to_uid,
  time,
  msg,
  partyid,
  host_uid
) => {
  const ref = isBeta
    ? database.ref("Beta/LatestMessages/")
    : database.ref("Live/LatestMessages/");
  try {
    return await ref
      .push({
        sender: from_uid,
        receiver: to_uid,
        msg: msg,
        time: time,
        partyid: partyid,
        from_host: from_uid === host_uid ? true : false,
      })
      .then(() => {});
  } catch (error) {
    return error;
  }
};

// 단건 이미지 보내기.
export const sendImg = async (
  isBeta,
  database,
  partyid,
  msg,
  from_uid,
  to_uid,
  time,
  isRead,
  host_uid,
  guest_uid,
  imgUrl
) => {
  // console.log(partyid, msg, from_uid, to_uid, time, isRead, host_uid, guest_uid);
  const ref = isBeta
    ? database.ref(
        "Beta/Messages/" + partyid + "@" + host_uid + "@" + guest_uid
      )
    : database.ref(
        "Live/Messages/" + partyid + "@" + host_uid + "@" + guest_uid
      );

  try {
    return await ref
      .push({
        message: {
          sender: from_uid,
          receiver: to_uid,
          msg: msg,
          time: time,
          isRead: isRead,
          imgUrl: imgUrl,
        },
      })
      .then(() => {
        if (from_uid !== 0) {
          // saveLatestMsg(isBeta, database, from_uid, to_uid, time, msg, partyid, host_uid)
        }
      });
  } catch (error) {
    return error;
  }
};

// 파티방 별 마지막 메세지 저장하기
export const saveEachRoomLastMsg = async (
  isBeta,
  database,
  partyid,
  msgValue,
  time,
  from_uid,
  to_uid,
  guest_uid,
  isRead
) => {
  // console.log(partyid,msgValue, time, from_uid, to_uid, guest_uid, isRead,"저장한다.");
  const ref = isBeta
    ? database.ref(
        "Beta/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid)
      )
    : database.ref(
        "Live/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid)
      );

  const ref2 = isBeta
    ? database.ref(
        "Beta/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      )
    : database.ref(
        "Live/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      );

  if (from_uid === guest_uid) {
    try {
      return await ref
        .update({
          message: {
            msg: msgValue,
            time: time,
            from: from_uid,
            to: to_uid,
            isRead: isRead,
          },
        })
        .then(() => {
          ref2.update({
            Guest_lastTime: time,
          });
        });
    } catch (error) {
      return error;
    }
  } else {
    try {
      return await ref
        .update({
          message: {
            msg: msgValue,
            time: time,
            from: from_uid,
            to: to_uid,
            isRead: isRead,
          },
        })
        .then(() => {
          ref2.update({
            Host_lastTime: time,
          });
        });
    } catch (error) {
      return error;
    }
  }
};

// 하루 보낸 메시지 제한 개수 체크
export const checkLimitSentCntADay = (user, sentCnt) => {
  const uid = user.loginSuccess.uid;
  const systemSetData = GetSystemSetData();
  const maxCnt = systemSetData.MAX_TALKCNT;

  let couldSend = false;
  if (sentCnt < maxCnt) {
    couldSend = true;
  } else {
    couldSend = false;
  }
  return couldSend;
};

// 하루 보낸 메세지 개수 리턴
export const getLimitSentCntADay = async (isBeta, database, user) => {
  const uid = user.loginSuccess.uid;
  let todayCnt = 0;
  const ref = isBeta
    ? database.ref("Beta/UserSentCnt/@" + String(uid))
    : database.ref("Live/UserSentCnt/@" + String(uid));

  try {
    return await ref
      .once("value", (snapshot) => {
        if (snapshot.val() !== null) {
          if (snapshot.val().day === moment().format("YYYY-MM-DD")) {
            // 오늘 이면,
            todayCnt = snapshot.val().sentCnt;
          } else {
            // 오늘이 아니면,
            todayCnt = 0;
          }
        } else {
          todayCnt = 0;
        }
      })
      .then(() => {
        // if(to)
        return todayCnt;
      });
  } catch (error) {
    return error;
  }
};

// 하루 보낸 메세지 개수 저장
export const saveLimitSentCntADay = async (isBeta, database, user, sentCnt) => {
  const uid = user.loginSuccess.uid;
  const ref = isBeta
    ? database.ref("Beta/UserSentCnt/@" + String(uid))
    : database.ref("Live/UserSentCnt/@" + String(uid));

  try {
    return await ref.update({
      day: moment().format("YYYY-MM-DD"),
      sentCnt: sentCnt,
    });
  } catch (error) {
    return error;
  }
};

// 신고 내용 저장
export const sendUserReport = async (
  isBeta,
  database,
  partyid,
  user,
  msgKeyList,
  time,
  reasonid,
  reason,
  to_uid,
  host_uid
) => {
  const uid = user.loginSuccess.uid;
  const ref = isBeta
    ? database.ref("Beta/UserReport/")
    : database.ref("Live/UserReport/");
  try {
    return await ref.push({
      time: time,
      msgList: msgKeyList,
      reasonid: reasonid,
      reason: reason,
      partyid: partyid,
      uid: uid,
      target: to_uid,
      owner: host_uid,
    });
  } catch (error) {
    return error;
  }
};

// 해당 유저가 현재 채팅방에 들어와 있는지.
export const checkNowOnRoom = async (
  isBeta,
  database,
  partyid,
  guest_uid,
  isHostChk
) => {
  let isTargetOnRoom = false;
  //  5분이 지나면 만료 시킨다.
  const time = new Date().getTime();

  const ref = isBeta
    ? database.ref(
        "Beta/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      )
    : database.ref(
        "Live/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      );

  try {
    if (isHostChk) {
      return await ref
        .once("value", (snapshot) => {
          if (
            snapshot.val().Host_uid > 0 &&
            (time - snapshot.val().Host_lastTime) / 60000 < 5
          ) {
            isTargetOnRoom = true;
          } else {
            isTargetOnRoom = false;
          }
        })
        .then(() => {
          return isTargetOnRoom;
        });
    } else {
      return await ref
        .once("value", (snapshot) => {
          if (
            snapshot.val().Guest_uid > 0 &&
            (time - snapshot.val().Guest_lastTime) / 60000 < 5
          ) {
            isTargetOnRoom = true;
          } else {
            isTargetOnRoom = false;
          }
        })
        .then(() => {
          return isTargetOnRoom;
        });
    }
  } catch (error) {
    return error;
  }
};

// 방에 입장한다.
export const EnterRoom = (
  isBeta,
  database,
  partyid,
  time,
  guest_uid,
  enter_uid
) => {
  const ref = isBeta
    ? database.ref(
        "Beta/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      )
    : database.ref(
        "Live/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      );

  const ref2 = isBeta
    ? database.ref(
        "Beta/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/message"
      )
    : database.ref(
        "Live/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/message"
      );

  // console.log("ddd", guest_uid, enter_uid);

  if (guest_uid === enter_uid) {
    ref.update({
      Guest_uid: enter_uid,
      Guest_lastTime: time,
    });
  } else {
    ref.update({
      Host_uid: enter_uid,
      Host_lastTime: time,
    });
  }

  // 읽음 처리
  // 입장인이 마지막 보낸 메세지의 수신자라면 읽음 처리를 한다.
  let toUserEnter = false;
  ref2
    .once("value", (snapshot) => {
      if (snapshot.val() !== null) {
        if (snapshot.val().to === enter_uid) {
          toUserEnter = true;
        }
      } else {
        toUserEnter = false;
      }
    })
    .then(() => {
      if (toUserEnter) {
        ref2.update({
          isRead: true,
        });
      }
    });
};

// 방에서 나간다.
export const ExitRoom = (isBeta, database, partyid, guest_uid, exit_uid) => {
  const ref = isBeta
    ? database.ref(
        "Beta/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      )
    : database.ref(
        "Live/PartyChatRooms/ROOM@" +
          String(partyid) +
          "/WITH@" +
          String(guest_uid) +
          "/loggedIn"
      );
  if (guest_uid === exit_uid) {
    ref.update({
      Guest_uid: 0,
    });
  } else {
    ref.update({
      Host_uid: 0,
    });
  }
};

// 시간 변경
export const unixTimeToTime = (time) => {
  var date = new Date(time);
  let today = moment().format("MM월 DD일");

  var year = date.getFullYear();
  var month = "0" + (date.getMonth() + 1);
  var day = "0" + date.getDate();
  var hour = "0" + date.getHours();
  var minute = "0" + date.getMinutes();
  // var second = "0" + date.getSeconds();

  if (today === month.substr(-2) + "월 " + day.substr(-2) + "일") {
    return (
      GetStringByKey(30005) + " " + hour.substr(-2) + ":" + minute.substr(-2)
    );
  } else {
    return (
      month.substr(-2) +
      "/" +
      day.substr(-2) +
      " " +
      hour.substr(-2) +
      ":" +
      minute.substr(-2)
    );
  }
};

// 시간 변경-채팅 룸
export const unixTimeToTimeForRooms = (time) => {
  var date = new Date(time);

  let today = moment().format("MM월 DD일");

  var year = date.getFullYear();
  var month = "0" + (date.getMonth() + 1);
  var day = "0" + date.getDate();
  var hour = "0" + date.getHours();
  var minute = "0" + date.getMinutes();
  // var second = "0" + date.getSeconds();
  if (today === month.substr(-2) + "월 " + day.substr(-2) + "일") {
    return hour.substr(-2) + ":" + minute.substr(-2);
  } else {
    return month.substr(-2) + "월 " + day.substr(-2) + "일";
  }
};

// 금지어 필터 체크
export const CheckFWord = (originMsg) => {
  let replaced_str = originMsg;
  for (let i = 0; i < fword.length; i++) {
    replaced_str = replaced_str?.replace(fword[i].INDEX, "***");
  }

  const val = {
    hasFword: originMsg !== replaced_str ? true : false,
    replaced: replaced_str,
    origin: originMsg,
  };

  // console.log(replaced_str);

  return val;
};
